import React from 'react'

type Props = {
  className?: string
  fillColor?: string
  size?: number
}

// Clock face with an upward arrow (Lucide clock-arrow-up) — used to flag
// not-yet-live, launching-soon content. The Figma asset exported under this
// same layer name was actually a clock+padlock glyph (a design-tool mismatch,
// not an intentional lock), so this draws the real clock-arrow-up shape
// instead. Stroked (not filled), matching the QuestionCircleOutline/
// BookOutline convention so it satisfies the shared outlined-icon test
// contract.
const ClockArrowUp = ({
  className,
  fillColor = 'currentColor',
  size = 16,
}: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="none"
    stroke={fillColor}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 6v6l1.56.78" />
    <path d="M13.227 21.925a10 10 0 1 1 8.767-9.588" />
    <path d="m14 18 4-4 4 4" />
    <path d="M18 22v-8" />
  </svg>
)

export default ClockArrowUp
